import React, { useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { Button, Input, Space, message } from 'antd';
import { usersApi } from '../_helpers/apiService';

interface SSNFormFieldProps {
  userId: number;
  value?: string;
  onChange?: (value: string) => void;
}

export const SSNFormField: React.FC<SSNFormFieldProps> = ({ userId, value, onChange }) => {
  const [ssn, setSSN] = useState<string | null>(value || null);
  const [isVisible, setIsVisible] = useState<boolean>(!!value);
  const [loading, setLoading] = useState<boolean>(false);

  const handleViewSSN = async () => {
    if (isVisible) {
      return; // Already visible, do nothing
    }

    setLoading(true);
    try {
      const response = await usersApi.getSSN(userId);
      setSSN(response.data.ssn);
      setIsVisible(true);
      if (onChange) {
        onChange(response.data.ssn);
      }
    } catch (error) {
      console.error('Error fetching SSN:', error);
      message.error('Регистрийн дугаар татахад алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  if (!isVisible) {
    return (
      <Space>
        <Input
          value="••••••••••"
          disabled
          style={{ width: 200 }}
        />
        <Button
          icon={<EyeOutlined />}
          loading={loading}
          onClick={handleViewSSN}
        >
          Харах
        </Button>
      </Space>
    );
  }

  return (
    <Input
      value={ssn || value}
      onChange={(e) => {
        setSSN(e.target.value);
        if (onChange) {
          onChange(e.target.value);
        }
      }}
    />
  );
};

export default SSNFormField;
